import { render, staticRenderFns } from "./Classified.vue?vue&type=template&id=1396d9e5&scoped=true"
import script from "./Classified.vue?vue&type=script&lang=js"
export * from "./Classified.vue?vue&type=script&lang=js"
import style0 from "./Classified.vue?vue&type=style&index=0&id=1396d9e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396d9e5",
  null
  
)

export default component.exports